export function showDuration(data) {
    if (data) {
        switch (data) {
            case 1: return '1 Month'
            case 3: return '3 Months'
            case 12: return '1 Year'
            default: return '1 Month'
        }
    }
    else return 'NA'
}

export function convertToInternation(val) {
    return Intl.NumberFormat('en-US', {
      notation: "compact",
      maximumFractionDigits: 1
    }).format(val);
  }